<template>
  <div>
    <!-- SIDEBAR TEMPLATES -->
    <sidebar-templates></sidebar-templates>    
    <!-- APPLY BODY -->
    <div class="apply-body">
      <!-- SUBNAV -->
      <div uk-sticky="animation: uk-animation-slide-top; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky;" class="uk-animation-slide-top-small">
        <nav class="uk-navbar-container uk-navbar-item body-navbar">
          <div class="uk-navbar-left" v-if="globalImages.uploadedImages.length == 0">
            <ul class="uk-navbar-nav">
                <span class="uk-text-small uk-text-muted uk-italics"><i>Add images below.</i></span>
            </ul>
          </div>          
          <div class="uk-navbar-left" v-if="globalImages.uploadedImages.length >= 1 && (globalSessionInfo.appliedWatermark === false || typeof globalSessionInfo.appliedWatermark === 'undefined')">
            <ul class="uk-navbar-nav">
                <span class="uk-text-small uk-text-muted uk-italics"><i>Select a watermark from "My Marks" or Export to resize your images.</i></span>
            </ul>
          </div>
          <div class="uk-navbar-left" v-if="globalImages.uploadedImages.length >= 1 && globalSessionInfo.appliedWatermark === true">
            <ul class="uk-navbar-nav">
                <span class="uk-text-small uk-text-muted uk-italics"><i>Images ready for Export.</i></span>
            </ul>
          </div>          
          <div class="uk-navbar-right">            
          <button v-if="globalImages.uploadedImages.length > 0" @click="$parent.restart()" class="uk-button uk-button-default uk-text-muted uk-text-capitalize uk-margin-right" style="border-radius: 20px;"><i>Restart</i></button>            
            <ul class="uk-navbar-nav">
              <li>
                <button class="uk-button uk-button-primary" uk-toggle="target: #offcanvas-flip" :disabled="globalImages.uploadedImages === undefined || globalImages.uploadedImages == 0"><b>Export</b></button>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      
      <upload-handler v-if="globalImages.uploadedImages === undefined || globalImages.uploadedImages.length == 0" ref="uploadHandler"></upload-handler>

      <!-- SINGLE IMAGE APPLY -->
      <single-apply v-if="globalImages.uploadedImages.length == 1"></single-apply>
      
      <!-- MULTI (GRID) IMAGE APPLY -->
      <multigrid-apply v-if="globalImages.uploadedImages.length > 1"></multigrid-apply>

      <!-- EXPORT OFF-CANVAS -->
      <div id="offcanvas-flip" uk-offcanvas="flip: true; overlay: true">
        <!-- EXPORT COMPONENT -->
        <export-apply ref="exportApply"></export-apply>
      </div>
    </div>
  </div>
</template>

<script>
  // Components
  import SidebarTemplates from './SidebarTemplates.vue'
  import MultigridApply from './MultigridApply.vue'
  import SingleApply from './SingleApply.vue'
  import UploadHandler from './UploadHandler.vue'
  import ExportApply from './ExportApply.vue'

  // Fitters
  import {fit} from '../../assets/js/fitters/fit.js'
  import {fitTiled} from '../../assets/js/fitters/fitTiled.js'
  import {fitBorder} from '../../assets/js/fitters/fitBorder.js'  

  // Vue
  import Vue from 'vue'

  export default {
    name: 'Apply',
    components: {
      'sidebar-templates': SidebarTemplates, 
      'multigrid-apply': MultigridApply,
      'single-apply': SingleApply,
      'upload-handler': UploadHandler,
      'export-apply': ExportApply
    },
    methods: {
      applyWatermark(index, mode) {        
        /* THIS IS THE MEAT AND POTATOES */

        var me;
        me = this;

        // if watermark in sidebar is clicked, but no images are imported... return and do nothing | this does not apply to exporting (export will not show unless images are imported)
        if ((mode === 'apply' || mode == null) && (me.globalImages.uploadedImages.length === 0 || me.globalImages.uploadedImages.length === null || me.globalSessionInfo.appliedWatermarkIndex === index)) {
          return
        }

        var idx = index;
        
        if (idx >= 0) {
          // fit standard
          let wmJson = this.globalMarks.savedMarks[idx].json 
          // fit tiled
          let tiledProperties = this.globalMarks.savedMarks[idx].tiledProperties 
          // fit border
          let borderProperties = this.globalMarks.savedMarks[idx].borderProperties
          // font and other various global state properties
          let fontProperties = this.globalMarks.savedMarks[idx].fontProperties    
          let wmWidth = this.globalMarks.savedMarks[idx].origWidth
          let wmHeight = this.globalMarks.savedMarks[idx].origHeight
          let wmType = this.globalMarks.savedMarks[idx].watermarkType                                        

          // set global selected watermark (this highlights watermark)
          Vue.set(me.globalSessionInfo, 'appliedWatermarkIndex', idx)       

            // start notification  
            Vue.set(me.globalSessionInfo, 'counterIndex', 0)            
            me.$notify({
                title: 'Applying',
                group: 'applying',
                duration: 100000,
                data: {length: this.globalImages.uploadedImages.length}
            });  

          function simpleComposite(nImg) {                            
            // comment above processComposites() explains how this promise is used
            return new Promise ((resolve, reject) => {

              // scaledWidth and scaledHeight are set on import. If < X mb, height = scaledHeight, if upload is huge > pre-scaled on import
              var imgWidth = me.globalImages.uploadedImages[nImg].properties.scaledWidth
              var imgHeight = me.globalImages.uploadedImages[nImg].properties.scaledHeight
              
              let compositeBackgroundImage = me.globalImages.uploadedImages[nImg].thumbnailURL            

              // FIT STANDARD
              if (wmType ==='full') {
                // whenever you use compositebackgroundImage in these functions it requires a callback!                    
                fit(wmJson, wmWidth, wmHeight, imgWidth, imgHeight, 'jpeg', 100, compositeBackgroundImage, 
                  function(result) {
                    //simpleComposite() is wrapped in a promise, and it needs to resolve() so the processComposites() loop can await it
                    resolve(result)
                  });    
              }

              // FIT TILED
              if (wmType ==='tiled') {                    
                fitTiled(tiledProperties, wmWidth, wmHeight, imgWidth, imgHeight, 'jpeg', 100, compositeBackgroundImage,
                  function(result) {
                    //simpleComposite() is wrapped in a promise, and it needs to resolve() so the processComposites() loop can await it
                    resolve(result)
                  });                      
              }

              // FIT BORDER
              if (wmType === 'border') {                    
                fitBorder(borderProperties, fontProperties, wmWidth, wmHeight, imgWidth, imgHeight, 'jpeg', 100, compositeBackgroundImage, 
                  function(result) {
                    //simpleComposite() is wrapped in a promise, and it needs to resolve() so the processComposites() loop can await it
                    resolve(result)
                  });                     
              }
            }) // << for mega promise
          }
              
          /* this beaut iterates through every image and applies a water in async succession. it does this by:
              1) using await for simpleComposite() which expects a promise to be returned
              2) simpleComposite() is wrapped in a Promise(resolve,reject) and resolves when callback from fit() is returned
              3) fit() still uses a super simple callback to call resolve() because promise-ception is a friggin nightmare
          */

          // async for+of loops require arrays
          var imageNumberArray = Array.apply(null, {length: me.globalImages.uploadedImages.length}).map(Number.call, Number) //makes simple array [0,1,2,...]
          async function processComposites() {
            for (const nImg of imageNumberArray) {
              Vue.set(me.globalSessionInfo, 'counterIndex', nImg)
              // await simpleComposite to complete
              var result = await simpleComposite(nImg)                  
              // then set values                  
              Vue.set(me.globalImages.uploadedImages[nImg], 'dataURL', result.watermarkComposite)
              Vue.set(me.globalImages.uploadedImages[nImg], 'watermark', result.watermark)
              Vue.set(me.globalSessionInfo, 'appliedWatermark', true)                  

              if (nImg === imageNumberArray[imageNumberArray.length-1]) {       
                // clear "applying x of y" card and say complete
                me.$notify({
                    group: 'applying',
                    clean: true,
                });   
                
                if (mode === 'apply' || mode == null) {
                  // user selecting watermark
                  me.finishApplying()
                } else {
                  // user exporting
                  me.$refs.exportApply.exportImagesProcess()
                  console.log('export image process invoked from apply.vue')
                }                                                
              }                      
            }
          }
          // processcomposite end

          // timeout is to allow for selectedId to set active css / start some stuff, etc so its not visually choppy with things crunching away at the get-go
          setTimeout(function(){ 
            processComposites()                 
          }, 50);                                     
        } 
      },
      finishApplying() {        
        this.$notify({
            title: 'Complete! <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>',
            text: 'Processed ' + this.globalImages.uploadedImages.length + ' images',
            group: 'loaded',
            type: 'success',
            duration: 2500
        });             
      },      
    }
  }

</script>

<style scoped>
  /* MAIN BODY + CANVAS */
  .apply-body {
      margin-left: 220px;
  }

  .apply-body .uk-button {
      border-radius: 2px;
  }
  
  .body-navbar {
      background: #F5F5F5 !important;
      box-shadow: 0 2px 2px -1px rgba(0,0,0,0.16) !important;
  }
</style>

<style>
  .upload-placeholder {
    margin-bottom: 25px;
    margin-top: 25px;
    padding: 160px 0 160px 0;
    background: rgb(240, 240, 240);
    border: 1px dashed #b4b4b4;
    border-radius: 5px;
  }

  .upload-dragover {
    background-color: #F5F5F5;
    border: 2px dashed #39f;
    box-shadow: 0 0 20px rgba(124, 124, 124, 0.6);
  }

</style>